export const iconMap = {
  docx: "/file-icons/Word",
  doc: "/file-icons/Word",
  dot: "/file-icons/Word",
  dotx: "/file-icons/Word",
  dotm: "/file-icons/Word",
  docm: "/file-icons/Word",
  rtf: "/file-icons/Word",
  rtx: "/file-icons/Word",
  xlsx: "/file-icons/Excel",
  xls: "/file-icons/Excel",
  xlsm: "/file-icons/Excel",
  xlsb: "/file-icons/Excel",
  xlt: "/file-icons/Excel",
  xltx: "/file-icons/Excel",
  xltm: "/file-icons/Excel",
  csv: "/file-icons/Default",
  pptx: "/file-icons/PowerPoint",
  ppt: "/file-icons/PowerPoint",
  pptm: "/file-icons/PowerPoint",
  pps: "/file-icons/PowerPoint",
  ppsx: "/file-icons/PowerPoint",
  ppsm: "/file-icons/PowerPoint",
  potm: "/file-icons/PowerPoint",
  potx: "/file-icons/PowerPoint",
  pdf: "/file-icons/_PDF",
  fdf: "/file-icons/_PDF",
  xfdf: "/file-icons/_PDF",
  jpg: "/file-icons/Image",
  jpeg: "/file-icons/Image",
  jfif: "/file-icons/Image",
  png: "/file-icons/Image",
  tif: "/file-icons/Image",
  tiff: "/file-icons/Image",
  gif: "/file-icons/Image",
  bmp: "/file-icons/Image",
  md: "/file-icons/Default",
  txt: "/file-icons/Default",
  zip: "/file-icons/Zip",
  dwg: "/file-icons/CAD",
  dxf: "/file-icons/CAD",
  dwf: "/file-icons/CAD",
  dgn: "/file-icons/CAD",
  msg: "/file-icons/Mail",
  eml: "/file-icons/Mail",
  ost: "/file-icons/Mail",
  pst: "/file-icons/Mail",
  vsdx: "/file-icons/Visio",
  dashboards: "/file-icons/Dashboard",
  pub: "/file-icons/Default",
  rvt: "/file-icons/Default",
  mp4: "/file-icons/Video",
  webm: "/file-icons/Video",
  ogg: "/file-icons/Video",
  ogv: "/file-icons/Video",
  default: "/file-icons/Default",

  rfa: "/file-icons/CAD",
  dwfx: "/file-icons/CAD",
  ifc: "/file-icons/CAD",
  nwc: "/file-icons/CAD",
  nwd: "/file-icons/CAD",
  stl: "/file-icons/CAD",
  lin: "/file-icons/CAD",
  pc3: "/file-icons/CAD",
  bak: "/file-icons/CAD",
  vtk: "/file-icons/simulation",
  vip: "/file-icons/simulation",
}

export const contentTypeMap = {
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  doc: "application/msword",
  dot: "application/msword",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  docm: "application/vnd.ms-word.document.macroEnabled.12",
  dotm: "application/vnd.ms-word.template.macroEnabled.12",
  rvt: "application/vnd.autodesk.autocad",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  xlt: "application/vnd.ms-excel",
  xlsm: "application/vnd.ms-excel.sheet.macroEnabled.12",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  xltm: "application/vnd.ms-excel.template.macroEnabled.12",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ppt: "application/vnd.ms-powerpoint",
  pps: "application/vnd.ms-powerpoint",
  pptm: "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
  potm: "application/vnd.ms-powerpoint.template.macroEnabled.12",
  potx: "application/vnd.openxmlformats-officedocument.presentationml.template",
  ppsx: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  ppsm: "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
  pdf: "application/pdf",
  fdf: "application/pdf",
  xfdf: "application/pdf",
  rtf: "application/rtf",
  eml: "message/rfc822",
  msg: "application/vnd.ms-outlook",
  pub: "application/x-mspublisher",
  vsdx: "application/vnd.visio",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  jfif: "image/jpeg",
  png: "image/png",
  tif: "image/tiff",
  tiff: "image/tiff",
  gif: "image/gif",
  bmp: "image/bmp",
  md: "text/markdown",
  csv: "text/csv",
  dwg: "application/acad",
  dxf: "application/dxf",
  dwf: "model/vnd.dwf",
  dgn: "image/vnd.dgn",
  zip: "application/zip",
  txt: "text/plain",
  mp4: "video/mp4",
  webm: "video/webm",
  ogg: "video/ogg",
  ogv: "video/ogg",
  rfa: "application/vnd.autodesk.revit",
  dwfx: "application/vnd.ms-pki.dwfx",
  ifc: "model/ifc",
  nwc: "application/vnd.autodesk.nwc",
  nwd: "application/vnd.autodesk.nwd",
  stl: "application/SLAv",
  lin: "text/plain",
  pc3: "application/octet-stream",
  bak: "application/octet-stream",
  vtk: "application/vtk",
  vip: "",
  btx: "application/octet-stream",
  err: "text/plain",
  xml: "text/xml",
  ics: "text/calendar",
}

export const previewableTypes = [
  "docx",
  "dotx",
  "docm",
  "dotm",
  "pdf",
  "pptx",
  "pptm",
  "xlsx",
  "xlsm",
  "jpg",
  "jpeg",
  "jfif",
  "png",
  "tif",
  "tiff",
  "bmp",
  "gif",
  "md",
  "mp4",
  "webm",
  "ogg",
  "ogv",
]

export const videoTypes = ["mp4", "webm", "ogg", "ogv"]

export const clickableTypes = [...previewableTypes, ...videoTypes]

export const getDeliverableExtension = (url: string): keyof typeof iconMap => {
  const extension = url.split(".").pop()?.toLowerCase() || ""
  return extension !== "" && iconMap[extension as keyof typeof iconMap]
    ? (extension as keyof typeof iconMap)
    : "default"
}
